<template>
  <div
    class="date"
    :class="$attrs.class"
  >
    <div class="date__wrapper">
      <Datepicker
        v-model="date"
        v-bind="{
          range,
          format,
          minDate,
          maxDate,
          locale: 'pt-BR',
          enableTimePicker
        }"
      />

      <input
        type="hidden"
        :name="name"
        :value="outputDate"
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Datepicker from '@vuepic/vue-datepicker'

import '@vuepic/vue-datepicker/dist/main.css'

export default defineComponent({
  name: 'GlobalDatePicker',

  components: {
    Datepicker
  },

  inheritAttrs: false,

  props: {
    name: {
      type: String,
      default: () => ''
    },

    range: {
      type: Boolean,
      default: () => false
    },

    enableTimePicker: {
      type: Boolean,
      default: () => false
    },

    modelValue: {
      type: [Date, String],
      default: () => ''
    },

    format: {
      type: String,
      default: () => 'dd/MM/yyyy'
    },

    separator: {
      type: String,
      default: () => '/'
    },

    outputLocale: {
      type: String,
      default: () => 'pt-BR'
    },

    minDate: {
      type: [Date, String, null],
      default: () => null
    },

    maxDate: {
      type: [Date, String, null],
      default: () => null
    }
  },

  emits: [
    'set-date',
    'update:modelValue'
  ],

  data () {
    return {
      date: null,
      date_request: null
    }
  },

  computed: {
    outputDate () {
      const { outputLocale } = this

      if (!this.date) {
        return ''
      }

      return this.date
        ?.toLocaleDateString(outputLocale)
        ?.replace(/\//g, `${this.separator}`) ?? ''
    }
  },

  watch: {
    date (date) {
      if (date !== this.modelValue) this.$emit('update:modelValue', date)

      if (date) return

      this.date = new Date()
    },

    modelValue (value) {
      this.date = value
    }
  },

  created () {
    this.date = this.modelValue ?? new Date()
  },

  methods: {
    formatRequest (date) {
      const { outputLocale } = this

      return date
        .toLocaleDateString(outputLocale)
        .replace(/\//g, `${this.separator}`)
    }
  }
})
</script>

<style lang="scss" scoped>
  .date {
    &__wrapper {
      width: 154px;
      height: 40px;

      div,
      input,
      :deep(div),
      :deep(input){
        height: 100% !important;
      }

      :deep(.dp__input_icon) {
        display: none;
      }

      :deep(.dp__pointer) {
        border-radius: var(--borderRadius, 24px);
        padding-inline: var(--paddingInline, 12px);
        border: solid var(--borderSize, 1px) var(--borderColor, rgb(var(--gray9)));

        letter-spacing: 0.05rem;
        color: var(--primary-dark2);
        font: 400 1.4rem / 2rem "Nunito", sans-serif;
      }
    }
  }
</style>
